import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faQrcode } from '@fortawesome/free-solid-svg-icons';


const EventFoodCouponSaveAction = ({ scanSource, scannedByUserId, scannedByUserName, scannedUserName, scannedUserCode, consumedBy, mealType, isChild, event, eventId, eventTitle }) => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [foodCouponData, setFoodCouponData] = useState([]);
  const [foodCouponSaved, setFoodCouponSaved] = useState([]);

  const buttonStyle = {
    padding: '10px 20px',
    margin: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  };

  const handleSaveFoodCoupon = async (scanSource, scannedByUserId, scannedByUserName, date, scannedUserName, scannedUserCode, consumedBy, mealType, isChild, eventId, eventTitle) => {
    
    const newFoodCoupon = {
      eventId,
      eventTitle,
      scannedByUserId,
      scannedByUserName,
      scannedDate: new Date(),  
      scannedUserName,
      scannedUserCode,
      consumedBy,
      mealType: mealType,
      isChild: isChild,
      scanSource,
      isActive: true,
      isDeleted: false
    };

    const config = {
        url: '/eventfoodcoupon/usecoupon',
        method: 'post',
        data: { newFoodCoupon },
        headers: { Authorization: authState.token },
      };
      // console.log('Inside FoodCoupon saved:', config);

  
      try {
        await fetchData(config);
        setFoodCouponSaved(true);
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    };

    const fieldError = (field) => (
        <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? 'block' : 'hidden'}`}>
          <i className='mr-2 fa-solid fa-circle-exclamation'></i>
          {formErrors[field]}
        </p>
      );


  

  const handleCancelClick = () => {
    // console.log("Cancel clicked");
  };

  const handleScanNextClick = (contactNumber) => {
    // console.log("Scanning next for contact:", contactNumber);
  };

  return (
    <div>
      <div className="flex flex-col text-xl text-blue-700 justify-center items-center mb-4">
        Dear {scannedUserName || 'Guest'}, 
        <span className="text-purple-700">{scannedUserCode}</span> 
        please get the coupon scanned before picking the plate.
      </div>

      <div className="flex flex-row">
        <button 
            onClick={() => handleSaveFoodCoupon(scanSource, scannedByUserId, scannedByUserName, new Date(), scannedUserName, scannedUserCode, consumedBy, mealType, isChild, eventId, eventTitle)} style={buttonStyle}>
          <FontAwesomeIcon icon={faSave} className="mr-2" /> Save
        </button>
        <button onClick={handleCancelClick} style={buttonStyle}>
          <FontAwesomeIcon icon={faTimes} className="mr-2" /> Cancel
        </button>
        <button onClick={() => handleScanNextClick(event?.contactNumber)} style={buttonStyle}>
          <FontAwesomeIcon icon={faQrcode} className="mr-2" /> Scan Next
        </button>
      </div>
    </div>
  );
};

export default EventFoodCouponSaveAction;
